// extracted by mini-css-extract-plugin
export default {"tab-container":"Tabs_tab-container__kidCU","tab-item":"Tabs_tab-item__PYSrh","badge":"Tabs_badge__ZssJv","active":"Tabs_active__2xnDX"};